import { render, staticRenderFns } from "./InstructorCourseAutoComplete.vue?vue&type=template&id=4b40e45d"
import script from "./InstructorCourseAutoComplete.vue?vue&type=script&lang=js"
export * from "./InstructorCourseAutoComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports